<script setup>
import ResponsiveView from "@/components/helper/ResponsiveView.vue";
// import DashboardDesktop from "@/components/dashboard/DashboardDesktop.vue";
import DashboardMobile from "@/components/dashboard/DashboardMobile.vue";
import DashboardSidebarMobile from "@/components/dashboard/DashboardSidebarMobile.vue";
</script>

<template>
  <ResponsiveView mobile-only>
    <DashboardMobile />
  </ResponsiveView>
  <ResponsiveView desktop-only>
    <DashboardSidebarMobile />
  </ResponsiveView>
</template>
